module.exports = __webpack_public_path__ + "img/電気回路_6_10.9542f575.png";